// eslint-disable-next-line import/prefer-default-export
export const NOTIFICATIONS_ES = {
  // Vacancy actions
  RequiredPermissions: 'Permisos requeridos otorgados',
  PermissionsRevoked: 'Permisos revocados',
  FileSaved: 'Archivo guardado',
  ErrorOccurred: 'Ocurrió un error, recarge la página',
  NoApplicantsYet: 'Todavía no hay candidatos que mostrar',
  Found: 'Obtuvimos ',
  Applicants: 'candidatos',
  NoEmptyName: 'El nombre de una columna no puede estar vacío',
  TryLater: 'Ocurrió un error, inténtelo de nuevo más tarde',
  ApplicantSaved: 'Candidato guardado',
  NoSavedAnymore: 'Candidato eliminado de lista de guardados',
  CandidateTransferred: 'Candidato transferido',
  AlreadyTransferred: 'Este candidato ya fue transferido a esta vacante',
  InvitationSent: 'Correo de invitación enviado',
  ImpossibleToDelete: 'Es imposible eliminar al candidato',
  VacancyUpdated: 'Vacante Actualizada',
  NoSameColumn: 'No se puede seleccionar la misma columna',
  AtLeastOne: 'Seleccione al menos 1 candidato',

  // Company actions
  DataInvoice: 'Faltan datos para facturación',
  CannotIntegrate: 'No se pudo integrar',
  TokenError: 'Error en el token',
  SatisfactionSurvey: 'Cuestionario de satisfacción guardado',
  IndustryUpdated: 'Industria actualizada',
  ImageAdded: 'Imagen agregada',
  ErrorWhileSaving: 'Hubo un error intentando guardar tus datos, intenta de nuevo',
  EmailFormat: 'Formatos de correo guardados',
  EmailSent: 'Correo enviado',
  LimitSaved: 'Límite guardado',
  EmptyField: 'Campo vacío',
  EmailSaved: 'Correo guardado',
  SpontaneousActivated: 'Vacante espontánea activada',
  SpontaneousDeactivated: 'Vacante espontánea desactivada',
  CardSaved: 'Tarjeta guardada',
  NewCard: 'Tarjeta nueva',
  DeclinedCard: 'Tarjeta declinada',
  UpdatedCard: 'Tarjeta actualizada',
  DeletedCard: 'Tarjeta eliminada',
  DeptoUpdated: 'Departamento actualizado',
  DeptoAdded: 'Departamento agregado',
  CompanyValues: `Valores de la empresa no se pudieron guardar`,
  DesirableValues: `Valores deseables guardados`,
  CouldNotSaveDesirableValues: `Valores deseables no se pudieron guardar`,
  SubdomainRegistered: 'Subdominio registrado',
  ErrorUpdatingSubdomain: 'Error al actualizar el dominio/subdominio',
  TemplateDeleted: 'Plantilla eliminada',

  // Survey index
  RangeWarning: 'Los rangos van de 0 a 10',
  MinimumOptions: 'Se requieren 2 opciones mínimo para ser pregunta cerrada',
  QuestionWarning: 'Pregunta vacía o ya existente',
  SelectWarning: 'Debe seleccionar un tipo de pregunta',

  // Spli form:
  FillAll: 'Rellene todos los campos',

  // Job actions
  SuccessfullySaved: '¡Guardamos tu vacante con éxito!',
  ErrorUpdatingVacancy: 'Un error ocurrió actualizando la vacante',
  VacancyPublished: `Vacante Publicada`,
  PaymentDone: 'Registramos tu pago con éxito',

  // User actions
  ErrorSendingEmail: 'Error al enviar correo, inténtelo más tarde',
  OutlookLinked: 'Outlook vinculado',
  SlackLinked: 'Slack vinculado',
  TeamsLinked: 'Teams vinculado',
  ErrorCode: 'Error con el código de verificación, inténtelo más tarde',
  PermissionsUpdated: 'Permisos actualizados',
  ErrorUpdatingPermissions: 'Error actualizando permisos',
  PermissionsObtained: 'Permisos obtenidos',
  EventSaved: 'Evento guardado',
  EventAlreadySaved: 'Lo sentimos, ya cuenta con un evento programado',
  UserUpdated: 'Usuario actualizado',
  UserRegistered: 'Usuario registrado',
  ImgUpdated: 'Imagen actualizada',
  UserDeleted: 'Usuario eliminado',
  CouldNotUpdate: 'La actualización falló, intente de nuevo',
  EmailAlreadyUsed: 'Este correo ya fue registrado en la plataforma',

  // loadCriterial
  CriterionUpdated: 'Criterio actualizado',
  CriterionSaved: 'Criterio guardado',
  CriterionDeleted: 'Criterio eliminado',
  TryAgainLater: 'Intenta de nuevo más tarde',
};
